// research-finding widget — α.4 of the outreach-agent slice.
//
// Renders inline in the outreach chat dock when the agent emits an
// `outreach.research.finding` event. The card is a deliberately
// minimal anchor tag (single click = open source in a new tab) so the
// founder can triage findings without leaving the dock. α.5+ may grow
// a Pin / Save action; today the persistence already happened — the
// projector wrote the finding to `prospects/{scopeId}/search_findings/`
// when EmitProspectEvent landed.
//
// Props mirror the @rmint/widgets `research-finding` schema (url +
// summary + source + findingId). Component accepts the registry's
// WidgetProps superset; we destructure the four we use.

import type { WidgetProps } from './registry';

export function ResearchFindingCard(props: WidgetProps) {
  const url = String(props.url ?? '');
  const summary = String(props.summary ?? '');
  const source = String(props.source ?? '');
  if (!url || !summary) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="research-finding-card"
      className="block rounded-md border border-border bg-card p-3 my-2 hover:bg-card/80 transition-colors"
    >
      <div className="text-xs text-foreground-mute">{source}</div>
      <div className="text-sm text-foreground mt-1">{summary}</div>
    </a>
  );
}
